/**
 * Deposit View
 */

define(function(require, exports, module) {
    'use strict';
    var CashierPaymentView = require('portlets/cashier/cashier.payment.view'),
        WithdrawMethodCollection = require('portlets/cashier/withdraw/withdraw.method.collection'),
        WithdrawMethodView = require('portlets/cashier/withdraw/withdraw.method.view');

    module.exports = CashierPaymentView.extend({

        MethodView: WithdrawMethodView,

        MethodsCollection: WithdrawMethodCollection,

        template: function(options) {
            return this.tmpl('withdraw', options);
        }

    });
});